"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const repeatWithHeaders_1 = (0, tslib_1.__importDefault)(require("./repeatWithHeaders"));
function default_1({ options, operation, forward }) {
    if (!operation || !forward)
        return;
    return (0, repeatWithHeaders_1.default)(async () => {
        const code = await options.promptTwoFactorCode();
        return {
            'X-ORION-TWOFACTOR': code
        };
    }, {
        operation,
        forward
    });
}
exports.default = default_1;
